export const normalizePaymentCategoryId = (value: string | number): string => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).replace(/\D/g, '');
};

export const formatPaymentCategoryId = (value: string | number): string => {
  const normalized = normalizePaymentCategoryId(value);

  if (!normalized) {
    return '';
  }

  const firstPart = normalized[0];
  const remaining = normalized.slice(1);

  const grouped = remaining.match(/.{1,2}/g) || [];

  return [firstPart, ...grouped].join('.');
};
